import {
  AddNewsActionsProps,
  ListButton,
  LoadMoreButton,
  NewsAddInput,
  NewsCard,
  NewsServiceName,
  NewsSourceOverrides,
  SelectedNewsSource,
  SiteConfig
} from "@bluframe/mightychroma-mightytool-frontend-types"
import { Props as ControlCheckboxesProps } from "components/Critics/ControlCheckboxes"

import Add from "./Add"
import { AddNewsActionCheckboxes } from "./Main"

interface Props {
  actionCheckboxes: Record<NewsServiceName, AddNewsActionCheckboxes>
  areNewsSourcesLoading: boolean
  avNirvana: SelectedNewsSource
  bluRay: SelectedNewsSource
  clearAllListsButtonProps: ListButton
  clearListButtonProps: Record<NewsServiceName, ListButton>
  hidefDigest: SelectedNewsSource
  isAdmin: boolean
  isEditor: boolean
  listAllButtonProps: ListButton
  listButtonProps: Record<NewsServiceName, ListButton>
  loadMoreButtonProps: Record<NewsServiceName, LoadMoreButton>
  news: NewsAddInput
  newsAddActionsProps: AddNewsActionsProps
  newsCards: Record<NewsServiceName, NewsCard>
  newsControlCheckboxesProps: ControlCheckboxesProps

  onClear: (serviceName: NewsServiceName) => () => void
  onSetOverrides: (
    serviceName: NewsServiceName
  ) => (overrides: NewsSourceOverrides) => void
  siteConfigNews: SiteConfig["news"]
  whySoBlu: SelectedNewsSource
}

export interface ComponentProps extends Props {}

export default Add
